import { Component } from 'react';
import PropTypes from 'prop-types';
import { matchRoutes } from 'react-router-config';
import { createRadioBrowseContext } from '../routes/utils/getBrowseContext';
import { createRadioProfileContext } from '../routes/utils/getProfileContext';

export default function withCurrentRouteProps(WrappedComponent) {
  class WithCurrentRouteInfo extends Component {
    shouldComponentUpdate({ location: nextLocation = {} }) {
      const { pathname, search } = this.props?.location || {};

      return (
        pathname !== nextLocation?.pathname || search !== nextLocation?.search
      );
    }

    render() {
      const { location, route } = this.props;

      const matchedRoutes = matchRoutes(route.routes, location.pathname);
      const currentRoute = matchedRoutes[0] || {};
      const routeLevelProps = currentRoute?.route?.routeLevelProps || {};

      // route props needed before the component has mounted
      const customRouteProps = { ...routeLevelProps };

      /*
        `match` seems to only be reliable on the route level and should be
        used wherever data needs to be fetched before rendering.

        matchUrl is set here specifically for the didRouteChange util because
        the match prop does not update consistently in nested components.
      */
      customRouteProps.matchUrl = currentRoute?.match?.url; // for didRouteChange

      // get title, guideId because we used to rely on those in the params property on the route
      customRouteProps.guideContext =
        createRadioProfileContext({ location, ...currentRoute }) ||
        createRadioBrowseContext({ location, ...currentRoute }) ||
        {};

      customRouteProps.guideContext.itemToken = location?.state?.itemToken;

      return <WrappedComponent {...this.props} routeProps={customRouteProps} />;
    }
  }

  WithCurrentRouteInfo.propTypes = {
    location: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  return WithCurrentRouteInfo;
}
